import React from "react";
import { Redirect, Route } from "react-router-dom";
import PropTypes from "prop-types";
import val from "../getThemeDetails";

const PrivateRoute = ({ component: Component, isAvailable, ...rest }) => {
  //console.log(Component, isAvailable);
  return (
    <Route
      {...rest}
      render={(props) =>
        isAvailable ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/index/login",
              search: `?walletOwnerId=${val.walletOwnerId}`,
            }}
          />
        )
      }
    />
  );
};

PrivateRoute.propTypes = {
  isAvailable: PropTypes.bool.isRequired,
  component: PropTypes.any.isRequired,
};

export default PrivateRoute;
